<template>
<svg class="icon-planet" viewBox="0 0 241.73 241.79" width="18" height="18">
    <path :fill="colorHex" d="M210.94,40.28c-11.23-12.55-24.66-22.41-39.91-29.37c-15.79-7.22-32.67-10.84-50.17-10.84h-0.17
	c-0.11,0-0.12-0.03-0.23-0.03l0.21-0.02V0c-0.4,0-0.12,0-0.14,0C103.13,0.06,86.3,3.74,70.6,10.94C55.4,17.9,42,27.81,30.81,40.31
	l4.73,4.28h-0.01l-4.74-4.28C10.94,62.49,0,91.09,0,120.87c0,29.78,10.97,58.39,30.82,80.57l4.77-4.25v0l-4.77,4.24
	c11.19,12.5,24.55,22.41,39.75,29.38c15.72,7.21,32.5,10.98,49.92,10.98h0l0,0h0h0l0,0c0,0,0.01,0,0.02,0l0,0h0.01
	c0.06,0,0.12,0,0.18,0h0.17c17.49,0,34.37-3.7,50.17-10.91c15.25-6.97,28.68-16.88,39.91-29.43c19.85-22.18,30.79-50.81,30.79-80.59
	C241.73,91.08,230.79,62.46,210.94,40.28z M228.81,114.57h-44.68c-0.49-18.29-3.04-35.76-7.5-51.58c10.3-2.76,19.7-6.24,28.04-10.42
	C219.06,70.2,227.48,91.9,228.81,114.57z M127.03,69.88c12.72-0.33,25.29-1.65,37.18-4.01c4.24,14.85,6.7,31.59,7.19,48.69h-44.37
	V69.88z M127.03,57.16V13.61c5.57,1.61,11.28,5.39,16.61,11.3c6.38,7.09,12.03,16.94,16.54,28.75
	C149.57,55.67,138.56,56.84,127.03,57.16z M114.31,13.61v43.54c-11.53-0.33-22.5-1.52-33.11-3.55c4.5-11.77,10.14-21.59,16.49-28.66
	C103.03,19.01,108.75,15.22,114.31,13.61z M77.17,65.81c11.88,2.38,24.42,3.71,37.14,4.06v44.69H69.99
	C70.47,97.47,72.92,80.68,77.17,65.81z M114.31,127.29v44.55c-12.72,0.35-25.26,1.76-37.14,4.13c-4.25-14.87-6.7-31.58-7.18-48.68
	H114.31z M114.31,184.56v43.54c-5.57-1.61-11.27-5.4-16.6-11.33c-6.36-7.07-12.01-16.89-16.51-28.66
	C91.8,186.08,102.78,184.89,114.31,184.56z M127.03,228.1v-43.55c11.53,0.31,22.54,1.48,33.15,3.5
	c-4.51,11.81-10.17,21.66-16.55,28.75C138.31,222.72,132.6,226.5,127.03,228.1z M164.22,175.9c-11.89-2.36-24.46-3.75-37.18-4.08
	v-44.54h44.37C170.92,144.38,168.46,161.05,164.22,175.9z M195.64,42.73c-6.89,3.16-14.64,5.9-22.92,8.09
	c-4.84-13.14-11.04-24.34-18.16-32.76c3.79,1.24,7.52,2.7,11.18,4.37C176.85,27.51,186.87,34.32,195.64,42.73z M75.85,22.5
	c3.56-1.63,7.18-3.06,10.86-4.28c-7.05,8.39-13.2,19.51-18,32.53c-8.24-2.19-15.8-4.87-22.62-8.01
	C54.81,34.36,64.79,27.57,75.85,22.5z M37.05,52.55c8.26,4.13,17.54,7.62,27.73,10.37c-4.47,15.84-7.03,33.35-7.52,51.64H12.91
	C14.25,91.9,22.67,70.18,37.05,52.55z M12.91,127.29h44.35c0.49,18.29,3.05,35.75,7.52,51.59c-10.19,2.75-19.47,6.23-27.73,10.37
	C22.67,171.62,14.25,149.95,12.91,127.29z M46.08,198.97c6.82-3.14,14.38-5.82,22.62-8.01c4.8,13.02,10.95,24.15,18,32.53
	c-3.68-1.23-7.3-2.65-10.86-4.28C64.79,214.14,54.81,207.35,46.08,198.97z M165.74,219.27c-3.66,1.67-7.39,3.13-11.18,4.37
	c7.12-8.42,13.32-19.63,18.16-32.76c8.27,2.2,16.02,4.93,22.92,8.09C186.87,207.39,176.85,214.2,165.74,219.27z M204.67,189.23
	c-8.34-4.18-17.73-7.65-28.04-10.42c4.45-15.81,7.01-33.63,7.5-51.52h44.68C227.48,149.95,219.06,171.6,204.67,189.23z"/>
</svg>
</template>
<script>
export default {
    props: {
        color: {
            type: String,
            default: 'grey',
            validator: function (direction) {
                return ['grey', 'white', 'red'].indexOf(direction) > -1
            }
        }
	},
	computed: {
		colorHex() {
			if (this.color === 'white') 	return '#FFFFFF'
			else if (this.color === 'grey') return '#636772'
			else if (this.color === 'red') 	return '#ff2b2a'

			return '#636772'
		}
	}
}
</script>
<style lang="sass" scoped>
@import "@/styles/vars.sass"
// path
//     fill: #636772
// .icon-planet.is-white
//     path
//         fill: #FFF
</style>
